import gql from 'graphql-tag';
import history from '../../history';
import { toastr } from 'react-redux-toastr';
import { setLoaderStart, setLoaderComplete } from '../../actions/loader/loader';
import getDriverOngoingBookings from '../../routes/site-admin/editDriver/getDriverOngoingBookings.graphql';

export function editDriver(id, firstName, lastName, email, password, phoneDialCode, phoneNumber, vehicleName, vehicleNumber, vehicleType, userStatus, isBan, phoneCountryCode, locationId, deliveryModuleIds) {
  return async (dispatch, getState, { client }) => {
    let errorMessage = 'Oops! something went wrong. Try again!';

    const mutation = gql`
        mutation updateDriver(
            $id: ID,
            $firstName: String,
            $lastName: String,
            $email: String,
            $password: String,
            $phoneDialCode: String
            $phoneNumber: String,
            $vehicleName: String,
            $vehicleNumber: String,
            $vehicleType: Int,
            $userStatus: String,
            $isBan: Int,
            $phoneCountryCode: String,
            $locationId: Int

            ) {
            updateDriver(
              id: $id
              firstName: $firstName
              lastName: $lastName
              email:$email
              password: $password
              phoneDialCode: $phoneDialCode
              phoneNumber: $phoneNumber
              vehicleName: $vehicleName
              vehicleNumber: $vehicleNumber
              vehicleType: $vehicleType
              userStatus: $userStatus
              isBan: $isBan
              phoneCountryCode: $phoneCountryCode
              locationId: $locationId
            )
            {
              status
              errorMessage
            }
          }
        `;

    const deliveryModulesMutation = gql`
        mutation updateDriverDeliveryModules($driverId: ID!, $deliveryModuleIds: [Int]) {
          updateDriverDeliveryModules(driverId: $driverId, deliveryModuleIds: $deliveryModuleIds) {
            status
            errorMessage
          }
        }
      `;

    const query = gql`
    query getAllDrivers($currentPage: Int, $searchList: String){
      getAllDrivers(currentPage: $currentPage, searchList: $searchList){
        count
        userData {
          id
          email
          phoneDialCode
          phoneNumber
          isBan
          userStatus
          createdAt
          profile {
            profileId
            firstName
            lastName
            country
          }
        }
      }
    }
    `;

    dispatch(setLoaderStart('EditDriver'));

    const { data } = await client.mutate({
      mutation,
      variables: {
        id,
        firstName,
        lastName,
        email,
        password,
        phoneDialCode,
        phoneNumber,
        vehicleName,
        vehicleNumber,
        vehicleType: Number(vehicleType),
        userStatus,
        isBan,
        phoneCountryCode,
        locationId: locationId ? Number(locationId) : undefined
      },
      refetchQueries: [{
        query,
        variables: {
          currentPage: 1
        }
      }, {
        query: getDriverOngoingBookings,
        variables: {
          id: String(id)
        }
      }]
    });

    if (data && data.updateDriver && data.updateDriver.status === 200) {
      await client.mutate({
        mutation: deliveryModulesMutation,
        variables: {
          driverId: id,
          deliveryModuleIds: deliveryModuleIds || []
        }
      });
    }

    dispatch(setLoaderComplete('EditDriver'));

    if (data && data.updateDriver && data.updateDriver.status === 200) {
      history.push('/siteadmin/drivers')
      toastr.success('Success!', 'Driver has been updated!')
    } else {
      errorMessage = (data && data.updateDriver && data.updateDriver.errorMessage) ? data.updateDriver.errorMessage : errorMessage;
      toastr.error("Error!", errorMessage);
    }
  }
}